module.exports = __webpack_public_path__ + "static/media/cookie-bite.b327ace8.svg";